import getApi from '@/lib/axios';
import { OccupancyModel } from '@/features/occupancyDashboard/types';

async function changeCapacidadeOccupancy(id: number, capacidade: number) {
  const api = await getApi();

  return api.patch<OccupancyModel>(`/painel-ocupacao/${id}/`, {
    capacidade,
  });
}

export { changeCapacidadeOccupancy };
